export default "__VITE_ASSET__filCcZuI__"